import React from "react";

import CnpMapImage from "assets/images/cnp-map.png";
import CnpMapMobileImage from "assets/images/cnp-map-mobile.png";
import CaixaSeguradoraMapImage from "assets/images/caixa-seguradora-map.png";
import CaixaSeguradoraMapMobileImage from "assets/images/caixa-seguradora-map-mobile.png";
import YouseMapImage from "assets/images/youse-map.png";
import YouseMapMobileImage from "assets/images/youse-map-mobile.png";
import CaixaSaudeMapImage from "assets/images/caixa-saude-map-image.png";
import CaixaSaudeMapMobileImage from "assets/images/caixa-saude-map-mobile.png";

const generalAssemblyDescription = (
  <p>
    A Assembleia Geral tem poderes para decidir sobre todos os negócios da
    Companhia e tomar as resoluções que julgar convenientes a sua defesa e
    desenvolvimento.
  </p>
);

const boardOfDirectorsDescription = (
  <p>
    É o órgão responsável por <strong>definir a estratégia corporativa</strong>{" "}
    e acompanhar sua execução pela Diretoria Executiva. Atua como elo entre os
    acionistas e a gestão, garantindo que as decisões estejam sempre alinhadas{" "}
    <strong>
      aos interesses de longo prazo da companhia e de seus stakeholders
    </strong>
    .
  </p>
);

const executiveBoardDescription = (
  <p>
    Responsável pela{" "}
    <strong>
      condução dos negócios e pela execução da estratégia aprovada
    </strong>{" "}
    pelo Conselho de Administração. A Diretoria atua com base nos princípios da
    governança corporativa, assegurando que cada decisão fortaleça a eficiência
    operacional e o propósito da empresa.
  </p>
);

export const EModals = {
  CNP_HOLDING_BRASIL_ASSEMBLEIA_GERAL: {
    title: "Assembleia Geral",
    subTitle: "CNP Seguros Holding Brasil",
    body: generalAssemblyDescription,
  },
  CNP_HOLDING_BRASIL_CONSELHO_ADMIN: {
    title: "Conselho de Administração",
    subTitle: "CNP Seguros Holding Brasil",
    body: (
      <>
        {boardOfDirectorsDescription}

        <p>
          <strong>Integrantes</strong>: Thomas Behar - Presidente (CNP) ; Julia
          Deiva (CNP) ; Sonia de Demandolx Furtado (CNP) ; Benoit Joseph Marie
          Piveteau (CNP) ; Eduardo Fabiano Alves da Silva (CNP) ; Maximiliano
          Alejandro Villanueva (CNP) ; Marcos Brasiliano Rosa (Seguridade) ;
          Miriam Aparecida Belchior (Seguridade) ; Cristina Kiomi Mori
          (Seguridade) ; Juliano Fernandes Bourim (Seguridade).
        </p>
      </>
    ),
  },
  CNP_HOLDING_BRASIL_COMITE_DE_PARTES_RELACIONADAS: {
    title: "Comitê de Partes Relacionadas",
    subTitle: "CNP Seguros Holding Brasil",
    body: (
      <>
        <p>
          Recomenda operações com empresas e demais partes relacionadas,
          assegurando que sejam conduzidas respeitando o interesse da companhia
          e de seus acionistas.
        </p>

        <p>
          <strong>Integrantes</strong>: Assizio A. de Oliveira - Coordenador
          (Independente) ; Paula Santiago dos Santos Cruz (Seguridade) ; Talita
          de Oliveira Leite (CNP).
        </p>
      </>
    ),
  },
  CNP_HOLDING_BRASIL_DIRETORIA_EXECUTIVA: {
    title: "Diretoria Executiva",
    subTitle: "CNP Seguros Holding Brasil",
    body: (
      <>
        {executiveBoardDescription}

        <p>
          <strong>Integrantes</strong>: Sany de Jesus Mota Silveira - Diretora
          Presidente ; Marco Antonio Barbosa Pires - Diretor Financeiro ; Jorge
          Alves- Diretor de Riscos e Controles Internos;.
        </p>
      </>
    ),
  },
  CNP_HOLDING_BRASIL_COMITE_DE_AUDITORIA: {
    title: "Comitê de Auditoria",
    subTitle: "CNP Seguros Holding Brasil",
    body: (
      <>
        <p>
          Tem a missão de{" "}
          <strong>
            acompanhar e fortalecer as atividades de auditoria interna e externa
          </strong>
          , além dos controles internos da organização. Atua com independência e
          reporta-se diretamente ao Conselho de Administração, em conformidade
          com a <strong>Resolução CNSP nº 432/2021</strong>.
        </p>

        <p>
          <strong>Integrantes</strong>: Assizio A. de Oliveira - Presidente
          (Independente) ; João Antonio Chiappa (CNP)
        </p>
      </>
    ),
  },
  CAIXA_SEGURADORA_ASSEMBLEIA_GERAL: {
    title: "Assembleia Geral",
    subTitle: "Caixa Seguradora S.A.",
    body: generalAssemblyDescription,
  },
  CAIXA_SEGURADORA_CONSELHO_DE_ADMIN: {
    title: "Conselho de Administração",
    subTitle: "Caixa Seguradora S.A.",
    body: (
      <>
        {boardOfDirectorsDescription}

        <p>
          <strong>Integrantes</strong>: Maximiliano Alejandro Villanueva -
          Presidente (CNP) ; Eduardo Fabiano Alves da Silva (CNP) ; Sany de
          Jesus Mota Silveira (CNP) ; Tãnia Maria de Oliveira (Seguridade) ;
          Daniel de Castro Borges (Seguridade).
        </p>
      </>
    ),
  },
  CAIXA_SEGURADORA_DIRETORIA_EXECUTIVA: {
    title: "Diretoria Executiva",
    subTitle: "Caixa Seguradora S.A.",
    body: (
      <>
        {executiveBoardDescription}

        <p>
          <strong>Integrantes</strong>: Sany de Jesus Mota Silveira - Diretora
          Presidente ; Marco Antonio Barbosa Pires - Diretor Financeiro ;
          Leticia de Oliveira Doherty - Diretora de Riscos e Controles Internos.
        </p>
      </>
    ),
  },
  CAIXA_SEGURADORA_CONSELHO_FISCAL: {
    title: "Conselho Fiscal",
    subTitle: "Caixa Seguradora S.A.",
    body: (
      <>
        <p>
          Órgão independente que{" "}
          <strong>fiscaliza os atos da administração</strong>, avaliando as
          ações do Conselho de Administração e da Diretoria Executiva. Zela pelo
          cumprimento dos deveres legais e estatutários, assegurando
          transparência e rigor na gestão,{" "}
          <strong>com report direto aos acionistas</strong>
        </p>

        <p>
          <strong>Integrantes</strong>: José Linaldo Gomes de Aquiar - Efetivo
          (CNP) ; Laudimiro Almeida da S. Filho - Efetivo (CNP) ; Jailton Zanon
          da Silveira - Efetivo (Seguridade) ; José Maurício D’Isep Costa -
          Suplente (CNP) ; José Ricardo Porto Rodrigues - Suplente (CNP) ;
          Juliana Grigol Fonsechi - Suplente (Seguridade)
        </p>
      </>
    ),
  },
  CAIXA_SEGURADORA_COMITE_DE_RISCOS: {
    title: "Comitê de Riscos",
    subTitle: "Caixa Seguradora S.A.",
    body: (
      <>
        <p>
          Responsável por{" "}
          <strong>
            assessorar a Administração na gestão de riscos corporativos
          </strong>
          , garantindo que todos os processos de identificação, avaliação,
          monitoramento e reporte de riscos estejam alinhados às melhores
          práticas e à Resolução CNSP nº 416/2021.
        </p>

        <p>
          <strong>Integrantes</strong>: Thereza Cristina Moreno de Oliveira -
          Coordenadora (Independente) ; Fernando de Rosa (Seguridade) ; Rodrigo
          Dias Freitas (CNP).
        </p>
      </>
    ),
  },
  YOUSE_ASSEMBLEIA_GERAL: {
    title: "Assembleia Geral",
    subTitle: "Youse Seguradora S.A.",
    body: generalAssemblyDescription,
  },
  YOUSE_CONSELHO_DE_ADMIN: {
    title: "Conselho de Administração",
    subTitle: "Youse Seguradora S.A.",
    body: (
      <>
        {boardOfDirectorsDescription}

        <p>
          <strong>Integrantes</strong>: Eduardo Fabiano Alves da Silva -
          Presidente (CNP) ; Sany de Jesus Mota Silveira (CNP) ; Maximiliano
          Alejandro Villanueva (CNP) ; Matheus Neves Sinibaldi ; Duncan Frank
          Semple (Seguridade).
        </p>
      </>
    ),
  },
  YOUSE_DIRETORIA_EXECUTIVA: {
    title: "Diretoria Executiva",
    subTitle: "Youse Seguradora S.A.",
    body: (
      <>
        {executiveBoardDescription}

        <p>
          <strong>Integrantes</strong>: Sany de Jesus Mota Silveira - Diretora
          Presidente ; Marco Antonio Barbosa Pires - Diretor Financeiro ;
          Leticia de Oliveira Doherty - Diretora de Riscos e Controles Internos.
        </p>
      </>
    ),
  },
  YOUSE_COMITE_DE_RISCO: {
    title: "Comitê de Riscos",
    subTitle: "Youse Seguradora S.A.",
    body: (
      <>
        <p>
          Responsável por{" "}
          <strong>
            assessorar a Administração na gestão de riscos corporativos
          </strong>
          , garantindo que todos os processos de identificação, avaliação,
          monitoramento e reporte de riscos estejam alinhados às melhores
          práticas e à <strong>Resolução CNSP nº 416/2021</strong>
        </p>

        <p>
          <strong>Integrantes</strong>: Thereza Cristina Moreno de Oliveira -
          Coordenadora (Independente) ; Fernando de Rosa (Seguridade) ; Rodrigo
          Dias Freitas (CNP).
        </p>
      </>
    ),
  },
  CAIXA_SEGURADORA_ESPECIALIZADA_EM_SAUDE_ASSEMBLEIA_GERAL: {
    title: "Assembleia Geral",
    subTitle: "Caixa Seguradora Especializada em Saúde S.A.",
    body: generalAssemblyDescription,
  },
  CAIXA_SEGURADORA_ESPECIALIZADA_EM_SAUDE_CONSELHO_DE_ADMIN: {
    title: "Conselho de Administração",
    subTitle: "Caixa Seguradora Especializada em Saúde S.A.",
    body: (
      <>
        {boardOfDirectorsDescription}

        <p>
          <strong>Integrantes</strong>: Sany de Jesus Mota Silveira - Presidente
          (CNP) ; Marco Antonio Barbosa Pires (CNP) ; Hebert Luiz Gomide Filho
          (Seguridade).
        </p>
      </>
    ),
  },
  CAIXA_SEGURADORA_ESPECIALIZADA_EM_SAUDE_DIRETORIA_EXECUTIVA: {
    title: "Diretoria Executiva",
    subTitle: "Caixa Seguradora Especializada em Saúde S.A.",
    body: (
      <>
        {executiveBoardDescription}

        <p>
          <strong>Integrantes</strong>: Marco Antonio Barbosa Pires - Diretor
          Presidente ; Leticia de Oliveira Doherty - Diretora Superintendente.
        </p>
      </>
    ),
  },
};

const AreaCardList = {
  CNP_HOLDING_BRASIL: [
    {
      coordsDesktop: "6,0,232,41",
      coordsMobile: "2,0,151,20",
      modal: EModals.CNP_HOLDING_BRASIL_ASSEMBLEIA_GERAL,
    },
    {
      coordsDesktop: "6,90,234,157",
      coordsMobile: "2,46,153,78",
      modal: EModals.CNP_HOLDING_BRASIL_CONSELHO_ADMIN,
    },
    {
      coordsDesktop: "276,13,506,75",
      coordsMobile: "182,7,335,38",
      modal: EModals.CNP_HOLDING_BRASIL_COMITE_DE_PARTES_RELACIONADAS,
    },
    {
      coordsDesktop: "278,90,507,156",
      coordsMobile: "182,46,335,78",
      modal: EModals.CNP_HOLDING_BRASIL_DIRETORIA_EXECUTIVA,
    },
    {
      coordsDesktop: "276,170,508,235",
      coordsMobile: "183,86,336,118",
      modal: EModals.CNP_HOLDING_BRASIL_COMITE_DE_AUDITORIA,
    },
  ],
  CAIXA_SEGURADORA: [
    {
      coordsDesktop: "5,3,274,51",
      coordsMobile: "1,1,182,30",
      modal: EModals.CAIXA_SEGURADORA_ASSEMBLEIA_GERAL,
    },
    {
      coordsDesktop: "3,86,276,167",
      coordsMobile: "2,49,182,96",
      modal: EModals.CAIXA_SEGURADORA_CONSELHO_DE_ADMIN,
    },
    {
      coordsDesktop: "3,185,276,236",
      coordsMobile: "0,107,181,137",
      modal: EModals.CAIXA_SEGURADORA_DIRETORIA_EXECUTIVA,
    },
    {
      coordsDesktop: "319,0,465,81",
      coordsMobile: "211,0,306,48",
      modal: EModals.CAIXA_SEGURADORA_CONSELHO_FISCAL,
    },
    {
      coordsDesktop: "330,126,506,209",
      coordsMobile: "216,73,334,123",
      modal: EModals.CAIXA_SEGURADORA_COMITE_DE_RISCOS,
    },
  ],
  YOUSE: [
    {
      coordsDesktop: "4,2,276,54",
      coordsMobile: "0,1,179,31",
      modal: EModals.YOUSE_ASSEMBLEIA_GERAL,
    },
    {
      coordsDesktop: "6,76,276,160",
      coordsMobile: "0,44,183,90",
      modal: EModals.YOUSE_CONSELHO_DE_ADMIN,
    },
    {
      coordsDesktop: "6,182,275,235",
      coordsMobile: "1,101,182,130",
      modal: EModals.YOUSE_DIRETORIA_EXECUTIVA,
    },
    {
      coordsDesktop: "330,119,508,206",
      coordsMobile: "218,66,334,115",
      modal: EModals.YOUSE_COMITE_DE_RISCO,
    },
  ],
  CAIXA_SEGURADORA_ESPECIALIZADA_EM_SAUDE: [
    {
      coordsDesktop: "7,1,506,58",
      coordsMobile: "2,0,334,49",
      modal: EModals.CAIXA_SEGURADORA_ESPECIALIZADA_EM_SAUDE_ASSEMBLEIA_GERAL,
    },
    {
      coordsDesktop: "6,76,506,162",
      coordsMobile: "0,66,334,118",
      modal: EModals.CAIXA_SEGURADORA_ESPECIALIZADA_EM_SAUDE_CONSELHO_DE_ADMIN,
    },
    {
      coordsDesktop: "8,181,506,238",
      coordsMobile: "1,137,334,185",
      modal:
        EModals.CAIXA_SEGURADORA_ESPECIALIZADA_EM_SAUDE_DIRETORIA_EXECUTIVA,
    },
  ],
};

export const cardsList = [
  {
    id: 1,
    title: "CNP Seguros Holding Brasil",
    subTitle: "14.045.781/0001-45",
    img: CnpMapImage,
    imgMobile: CnpMapMobileImage,
    imgMap: AreaCardList.CNP_HOLDING_BRASIL,
  },
  {
    id: 2,
    title: "Caixa Seguradora S.A.",
    subTitle: "34.020.354/0001-10",
    img: CaixaSeguradoraMapImage,
    imgMobile: CaixaSeguradoraMapMobileImage,
    imgMap: AreaCardList.CAIXA_SEGURADORA,
  },
  {
    id: 3,
    title: "Youse Seguradora S.A.",
    subTitle: "24.856.160/0001-03",
    img: YouseMapImage,
    imgMobile: YouseMapMobileImage,
    imgMap: AreaCardList.YOUSE,
  },
  {
    id: 4,
    title: "Caixa Seguradora Especializada em Saúde S.A.",
    subTitle: "13.223.975/0001-20",
    img: CaixaSaudeMapImage,
    imgMobile: CaixaSaudeMapMobileImage,
    imgMap: AreaCardList.CAIXA_SEGURADORA_ESPECIALIZADA_EM_SAUDE,
  },
];
